import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.75 4.875C4.16421 4.875 4.5 5.21079 4.5 5.625V8.625H9V5.625C9 5.21079 9.33579 4.875 9.75 4.875C10.1642 4.875 10.5 5.21079 10.5 5.625V13.125C10.5 13.5392 10.1642 13.875 9.75 13.875C9.33579 13.875 9 13.5392 9 13.125V10.125H4.5V13.125C4.5 13.5392 4.16421 13.875 3.75 13.875C3.33579 13.875 3 13.5392 3 13.125V5.625C3 5.21079 3.33579 4.875 3.75 4.875Z",
      fill: "#3F3F46"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12 12.8009C13.8929 11.5309 14.8393 10.5212 14.8393 9.7715C14.8393 9.31276 14.628 9.08339 14.2054 9.08339C13.9673 9.08339 13.7917 9.16171 13.6786 9.31836C13.5714 9.475 13.5119 9.71836 13.5 10.0484H12.0089C12.0446 9.32675 12.2768 8.78409 12.7054 8.42045C13.1339 8.05682 13.6756 7.875 14.3304 7.875C15.0149 7.875 15.5298 8.03724 15.875 8.36171C16.2262 8.68619 16.4018 9.10857 16.4018 9.62885C16.4018 10.2051 16.1667 10.7701 15.6964 11.324C15.2262 11.8722 14.6637 12.3365 14.0089 12.717H16.5V13.875H12V12.8009Z",
      fill: "#3F3F46"
    }, null, -1)
  ])))
}
export default { render: render }